// 题目类型
import request from '@/router/axios';

let urlPrefix = '/api/exam/etquestiontype';

/**
 * 获取题目类型列表
 */
export const getEtquestiontypeList = () => {
    return request(`${urlPrefix}/all`);
};